// Keep track of number of annotations
export let ANNOTATIONS_COUNT = 0
// minimum width and height of a bounding box
const MIN_SIZE = 5

/**
 * Model for storing the details of an annotation, including bounding box and the
 * label attributes
 */
export default class Annotation {
  // constructor(x0, y0, x1, y1) {
  //   this.id = ''
  //   this.x0 = x0
  //   this.y0 = y0
  //   this.x1 = x1
  //   this.y1 = y1
  //   this.title = ''
  //   this.label = ''
  //   this.attributes = {}
  //
  //   // Increment ANNOTATIONS_COUNT upon creation.
  //   ANNOTATIONS_COUNT++
  // }

  // Tried extension #1 - copy

    constructor(x0, y0, x1, y1, index) {
    this.id = ''
    this.x0 = x0
    this.y0 = y0
    this.x1 = x1
    this.y1 = y1
    this.title = ''
    this.label = ''
    this.attributes = {}
    // For copied annotations
    this.testId = `${(index + 1).toString().padStart(4, '0')}.jpg`
        this.newId = ANNOTATIONS_COUNT;
    // Increment ANNOTATIONS_COUNT upon creation.
    ANNOTATIONS_COUNT++
  }



  setTopLeft(x, y) {
    this.setLeft(x)
    this.setTop(y)
  }

  setTopRight(x, y) {
    this.setRight(x)
    this.setTop(y)
  }

  setBottomLeft(x, y) {
    this.setLeft(x)
    this.setBottom(y)
  }

  setBottomRight(x, y) {
    this.setRight(x)
    this.setBottom(y)
  }

  setTop(y) {
    if (this.y1 - y < MIN_SIZE) {
      this.y0 = this.y1 - MIN_SIZE
    } else {
      this.y0 = y
    }
  }

  setBottom(y) {
    if (y - this.y0 < MIN_SIZE) {
      this.y1 = this.y0 + MIN_SIZE
    } else {
      this.y1 = y
    }
  }

  setLeft(x) {
    if (this.x1 - x < MIN_SIZE) {
      this.x0 = this.x1 - MIN_SIZE
    } else {
      this.x0 = x
    }
  }

  setRight(x) {
    if (x - this.x0 < MIN_SIZE) {
      this.x1 = this.x0 + MIN_SIZE
    } else {
      this.x1 = x
    }
  }

  // update all corners by a dx and dy
  updatePos(dx, dy) {
    this.x0 += dx
    this.x1 += dx
    this.y0 += dy
    this.y1 += dy
  }

  // ensure x0 < x1 and y0 < y1 and has the minimum size
  sortBoundingBoxValues() {
    if (this.x0 > this.x1) {
      const x0 = this.x0
      this.x0 = this.x1
      this.x1 = x0
    }
    if (this.y0 > this.y1) {
      const y0 = this.y0
      this.y0 = this.y1
      this.y1 = y0
    }
    if (this.x1 - this.x0 < MIN_SIZE) {
      this.x1 = this.x0 + MIN_SIZE
    }
    if (this.y1 - this.y0 < MIN_SIZE) {
      this.y1 = this.y0 + MIN_SIZE
    }
  }

  getX() {
    return Math.min(this.x0, this.x1)
  }

  getY() {
    return Math.min(this.y0, this.y1)
  }

  getWidth() {
    return Math.abs(this.x1 - this.x0)
  }

  getHeight() {
    return Math.abs(this.y1 - this.y0)
  }
}
